export function isUserAuthenticated(state) {
    return state["features/auth"]?.isAuthenticated ?? false;
}
export function getAuthStep(state) {
    return state["features/auth"]?.step ?? "phone";
}
export function getPhoneNumber(state) {
    return state["features/auth"]?.phoneNumber ?? "";
}
export function getUserInfo(state) {
    return state["features/auth"]?.userInfo ?? null;
}
export function isLoginModalOpen(state) {
    return state["features/auth"]?.isLoginModalOpen ?? false;
}
export function getPendingRoom(state) {
    return state["features/auth"]?.pendingRoom ?? null;
}
export function getAuthLoading(state) {
    return state["features/auth"]?.loading ?? false;
}
export function getAuthError(state) {
    return state["features/auth"]?.error ?? null;
}
/**
 * Generates a UUID v7-like room ID with 4 extra characters.
 * Format: xxxxxxxx-xxxx-7xxx-yxxx-xxxxxxxxxxxx + 4 extra chars
 * Total length: 40 characters (36 standard UUID + 4 extra)
 * Example: 9950cd43-f858-7fbb-b8ba-7cfd967b54a4783e
 *
 * @returns {string} The generated room ID.
 */
export function generateRoomId() {
    // Generate random hex characters
    const getRandomHex = (length) => {
        let result = "";
        for (let i = 0; i < length; i++) {
            result += Math.floor(Math.random() * 16).toString(16);
        }
        return result;
    };
    // Get timestamp-based first segment (8 chars)
    const timestamp = Date.now().toString(16).padStart(12, "0").slice(-8);
    // Generate random parts
    const part2 = getRandomHex(4); // 4 chars
    const part3 = "7" + getRandomHex(3); // 7 + 3 chars = 4 chars (UUID v7 indicator)
    const variantChar = ["8", "9", "a", "b"][Math.floor(Math.random() * 4)]; // Variant bits
    const part4 = variantChar + getRandomHex(3); // variant + 3 chars = 4 chars
    const part5 = getRandomHex(12); // 12 chars
    const extraChars = getRandomHex(4); // 4 extra chars
    return `${timestamp}-${part2}-${part3}-${part4}-${part5}${extraChars}`;
}
export function ensureDeviceId() {
    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
        deviceId = generateRoomId();
        localStorage.setItem("deviceId", deviceId);
    }
    return deviceId;
}
